import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ModuleType } from "@app/core/enums/module-type.enum";
import { RequestType } from "@app/core/enums/request-type.enum";
import { ActionCommand } from "../action-command-interface";

export class AddNewAddressCommand implements ActionCommand {
  constructor(private renderEngineComponent: any) { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    requestData.requestType = RequestType.PAGE_FETCH;
    requestData.module = ModuleType.CHECKOUT;
    this.renderEngineComponent.navigateTo(['/order/address/new'], {
      queryParams: {
        type: actionData?.params.type,
      },
    });
    return
  }
}